import { call, fork, put, take } from 'redux-saga/effects';

import { message } from 'antd';
import translations from 'translations';
import { submitKeepInTouchFormApi } from 'utils/apollo';
import { contactUs as contactUsActions } from './actions';
import ActionTypes from './constants';
import messages from './messages';

export const isMobile = window.document.body.clientWidth < 768;

function* contactUsFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.CONTACT_US_SUBMIT);
    const { values, cb } = payload;
    let response;
    try {
      response = yield call(submitKeepInTouchFormApi, {
        input: {
          ...values,
        },
      });
      if (!response.errors) {
        yield put(contactUsActions.success());
        message.success(translations(messages.contactUsSuccess));
      } else {
        yield put(contactUsActions.failure(response.errors));
        response.errors.map((e: any) => message.error(e.message));
      }
    } finally {
      if (cb) {
        cb(response);
      }
    }
  }
}

export default function* saga() {
  yield fork(contactUsFlow);
}
